import Checkbox from 'components/form/Checkbox';
import Select from 'components/form/Select';
import TextField from 'components/form/TextInput';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getCustomColumns } from 'services/account.service';
import { CONTACT_FIELDS } from '../../../constants/smartSaveFields';

const BasicOptions = ({ values, onChange }) => {
  const [t] = useTranslation('connectCard');
  const [customFields, setCustomFields] = useState([]);
  const account = useSelector((state) => state.settings.account);

  useEffect(() => {
    getCustomColumns(account.hash).then(setCustomFields);
  }, []);

  const fieldOptions = [
    {
      label: 'Contact',
      options: CONTACT_FIELDS.filter(
        (i) =>
          i.field_type.includes(values.question_type) ||
          i.field_type.includes('*'),
      ),
    },
    {
      label: 'Contact Custom Fields',
      options: customFields.map((field) => ({
        label: field.column_name,
        value: 'custom.' + field.column_name,
      })),
    },
  ];

  const isRequiredQuestion = values.is_first_name === '1';

  return (
    <>
      <TextField
        fullWidth
        value={values.question_label}
        onChange={(e) => onChange({ question_label: e.target.value })}
        placeholder={t(
          'edit-heading-for-this-question-placeholder',
          'Edit the heading for this question',
        )}
      />
      <Checkbox
        disabled={isRequiredQuestion}
        checked={values.question_required === '1'}
        onChange={(e) =>
          onChange({ question_required: e.target.checked ? '1' : '0' })
        }
        label={t('required-field-label', 'Mark as a required field')}
        hint={t(
          'required-field-hint',
          'Users cannot continue without answering this question',
        )}
      />
      <Checkbox
        checked={values.question_settings.smartSave}
        onChange={(e) => {
          onChange({
            question_settings: {
              ...values.question_settings,
              smartSave: e.target.checked,
              smartSaveField: undefined,
            },
          });
        }}
        label={t('smart-save-label', 'Smart Save')}
        hint={t(
          'smart-save-link-hint',
          'Link this answer to any of the variables found under each contact.',
        )}
      />
      {values.question_settings.smartSave && (
        <Select
          transformValue
          sx={{ minWidth: 200 }}
          value={values.question_settings.smartSaveField}
          onChange={(val) => {
            onChange({
              question_settings: {
                ...values.question_settings,
                smartSaveField: val,
              },
            });
          }}
          menuPosition="fixed"
          placeholder={t('link-to-variable-placeholder', 'Link to variable')}
          options={fieldOptions}
        />
      )}
    </>
  );
};

export default BasicOptions;
